





















































































































import {
  computed,
  defineComponent,
  ref
} from '@vue/composition-api'

import { RoutePath as routes, RouteName as routeNames } from '@/router'
import { AnslLink } from './common'

export default defineComponent({
  components: { AnslLink },
  setup (_, context) {
    const mobileMenuVisible = ref<boolean>(false)
    const mobileWrapperPageOverlay = ref<HTMLElement | null>(null)
    const mobileWrapper = ref<HTMLElement | null>(null)

    const isCurrentRouteLandlord = computed(() => context.root.$route.path.includes(routes.LandlordPage))

    const handleMobileMenuState = (event: MouseEvent) => {
      const target = event.target as HTMLElement

      const overlayClicked = target === mobileWrapperPageOverlay.value
      // TODO: come up with a better solution, maybe?
      const navigationClicked = target.tagName === 'A' || target.tagName === 'IMG'

      if (overlayClicked || navigationClicked) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        toggleMobileMenu()
      }
    }

    const toggleMobileMenu = () => {
      mobileMenuVisible.value = !mobileMenuVisible.value

      document.body.style.overflow = mobileMenuVisible.value ? 'hidden' : 'visible'

      // we don't want the event to fire even when the mobile menu is hidden
      if (mobileMenuVisible.value) {
        mobileWrapperPageOverlay.value?.addEventListener('click', handleMobileMenuState)
      } else {
        mobileWrapperPageOverlay.value?.removeEventListener('click', handleMobileMenuState)
      }
    }

    return {
      routes,
      routeNames,
      mobileMenuVisible,
      isCurrentRouteLandlord,
      toggleMobileMenu,
      handleMobileMenuState,
      mobileWrapperPageOverlay,
      mobileWrapper
    }
  }
})
